import React from 'react'
import {Button, Modal} from 'semantic-ui-react'
import OASEditor from './oas-editor'
import {useSafeState} from '../../../../hook'

const OASEditorModal = (
  {
    contract = {definition: ''},
    onSave,
    onClose
  }
) => {
  const [saving, setSaving] = useSafeState(false)

  const save = async () => {
    setSaving(true)
    await onSave()
  }

  return (
    <Modal size='fullscreen' open={true} closeOnDimmerClick={false} closeIcon={true} onClose={onClose}
           closeOnEscape={false}
           data-testid='oas-editor-modal'
           style={{height: '100vh !important', width: '100vw !important'}}>
      <Modal.Header>
        Swagger Editor
      </Modal.Header>
      <Modal.Content style={{height: '80vh'}}>
        <div style={{height: '100%', display: 'inline-block'}}>
          <OASEditor domId='#swagger-editor' contract={contract}/>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} data-testid='oas-editor-close-button'>Close</Button>
        <Button primary onClick={save}
                data-testid='oas-editor-submit-button'
                loading={saving}>Save</Button>
      </Modal.Actions>
    </Modal>
  )
}

export {OASEditorModal}


export default OASEditorModal